export default "__VITE_ASSET__e22bf6ed__"